module.exports = __webpack_public_path__ + "static/media/play-boss-5.21b292f6.png";